// TagsInput.jsx
import React from "react";
import { useEffect } from "react";
let uniqueArr = [];

const TagsInput = ({ selectedTags, setAddTags, handleTags ,setDescTags}) => {
  const [tags, setTags] = React.useState([]);

  useEffect(() => {
    uniqueArr = [...new Set(selectedTags.map((item) => item))];
    setTags(uniqueArr.filter((item) => item));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedTags]);
  const addTags = (event) => {
    event.preventDefault();
    // console.log(event)
    if (event.key === "Enter" && event.target.value !== "") {
      setTags([...tags, event.target.value]);
      setAddTags([...selectedTags, event.target.value]);
      setDescTags(true)
      event.target.value = "";
    }
  };

  const removeTags = (index) => {
    setTags([...tags.filter((tag) => tags.indexOf(tag) !== index)]);
    setAddTags([
      ...selectedTags.filter((tag) => selectedTags.indexOf(tag) !== index),
    ]);
  };

  return (
    <div className="tags-input p-0">
      {tags.length > 0 && (
        <ul id="tags">
          {tags.map((tag, index) => (
            <li key={index} className="tag">
              <span className="tag-tile">{tag}</span>
              <i className="tag-close-icon" onClick={() => removeTags(index)}>
                x
              </i>
            </li>
          ))}
        </ul>
      )}
      <input
        type="text"
        placeholder="Press enter to add tags"
        onKeyUp={(event) => addTags(event)}
        onBlur={handleTags}
      />
    </div>
  );
};
export default TagsInput;
